// removed by extract-text-webpack-plugin
module.exports = {"data-link":"data-link___e23h- space-top-8___2eGOi","data-link-in":"data-link-in___pcSvm center___2iqBf","solutions-list":"solutions-list___2isk8"};